<template>
    <div>
        <v-app>
            <router-view></router-view>
            <div class="mask" v-if="snackbar.open" @touchmove.prevent></div>
            <v-snackbar :value="snackbar.open" :top="true" :vertical="true" :timeout="0">
                {{ snackbar.text }}
                <v-btn color="pink" flat @click="onSnackbarConfirmed">{{ buttonText }}</v-btn>
            </v-snackbar>
        </v-app>
        <v-fade-transition>
            <div class="loading" v-show="loading" @touchmove.prevent>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <p>努力加载中...</p>
            </div>
        </v-fade-transition>
        <v-fade-transition>
            <div class="sm-loading-dimmer" v-show="smLoading" @touchmove.prevent>
                <div class="sm-loading-modal">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    <p style="margin-top: 15px;">请稍等...</p>
                </div>
            </div>
        </v-fade-transition>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import userApi from '@/api/user'

    export default {
        name: 'App',
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                'snackbar',
                'loading',
                'smLoading'
            ]),
            buttonText() {
                if (this.snackbar.action === 'refresh') {
                    return '刷新'
                } else if (this.snackbar.action === 'login') {
                    return '登录'
                } else {
                    return '关闭'
                }
            }
        },
        methods: {
            ...mapActions([
                'HideSnackbar'
            ]),
            onSnackbarConfirmed() {
                if (this.snackbar.action === 'refresh') {
                    window.location.reload()
                } else if (this.snackbar.action === 'login') {
                    window.location.href = userApi.getAuthUrl(this.$route.fullPath)
                } else {

                }
                this.HideSnackbar()
            }
        },
    }
</script>

<style lang="scss">
    .mask {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: black;
        opacity: 0.7;
        z-index: 20;
    }

    .loading {
        top: 0;
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: white;
        z-index: 21;
        text-align: center;
        padding-top: calc(50vh - 30px);

        p {
            margin-top: 20px;
        }
    }

    .sm-loading-dimmer {
        top: 0;
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: 999999;
        background: transparent;
        text-align: center;

        .sm-loading-modal {
            background: black;
            opacity: 0.85;
            width: 120px;
            padding: 20px;
            color: white;
            border-radius: 8px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-top: -60px;
            margin-left: -60px;
        }
    }
</style>
